import * as yup from "yup";
import "data/yup-validation";

export const propertyInfoSchema = yup.object({
  legalName: yup.string().required("Property legal name is required"),
  phone: yup
    .string()
    .validUSPhoneNumber("Invalid phone number")
    .required("Phone number is required"),
  phoneExtension: yup.string(),
  email: yup
    .string()
    .validEmail("Invalid email format")
    .required("Property email is required"),
  inDevelopment: yup.boolean().required(),
  address1: yup
    .string()
    .when("inDevelopment", ([inDev], schema) =>
      (inDev ? schema : schema.required("Address is required"))),
  address2: yup.string(),
  city: yup
    .string()
    .when("inDevelopment", ([inDev], schema) =>
      (inDev ? schema : schema.required("City is required"))),
  state: yup
    .string()
    .when("inDevelopment", ([inDev], schema) =>
      (inDev ? schema : schema.required("State is required"))),
  zip: yup
    .string()
    .when("inDevelopment", ([inDev], schema) =>
      (inDev ? schema : schema
        .required("Zip code is required")
        .matches(/^\d{5}(?:-\d{4})?$/, "ZIP code must be 12345 or 12345-6789"))),
});


